var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-fb-control"},[(_vm.showType == 'form-builder')?_c('b-form-group',{style:(_vm.properties.style),attrs:{"description":_vm.properties.description,"label":_vm.properties.label}},[_c('v-select')],1):_vm._e(),(_vm.showType == 'properties')?_c('div',[_c('dropdown-v2-properties',{attrs:{"formId":_vm.formId}})],1):_vm._e(),(
      _vm.showType == 'form-submitter' ||
        (_vm.showType == 'e-form' && _vm.properties.eFormEditable)
    )?_c('b-form-group',{staticStyle:{"font-size":"14px"},style:(_vm.properties.style),attrs:{"description":_vm.computedConditions.description
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'description',
            value: _vm.properties.description,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.description,"label":_vm.computedConditions.label
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'label',
            value: _vm.properties.label,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.label,"hidden":_vm.computedHidden,"state":_vm.state,"invalid-feedback":_vm.errors.join(', ')}},[_c('v-select',{staticStyle:{"font-size":"14px"},style:(`--bg-color:${_vm.properties.pickerBgColor ? _vm.properties.pickerBgColor : 'white'};`),attrs:{"options":[
        ..._vm.superComputeFormSubmitterValue({
          elementId: this.id,
          property: 'options',
          value: _vm.properties.options,
          defaultValue: [],
          form: this.form
        }),
        ...(_vm.properties.includeOther ? ['Other'] : [])
      ],"multiple":_vm.properties.multiselect},model:{value:(_vm.controlValue),callback:function ($$v) {_vm.controlValue=$$v},expression:"controlValue"}}),(_vm.controlValue == 'Other')?_c('b-form-input',{staticClass:"mt-2",attrs:{"placeholder":"Type value..."},on:{"blur":function($event){_vm.controlValueOther = _vm.localValueOther}},model:{value:(_vm.localValueOther),callback:function ($$v) {_vm.localValueOther=$$v},expression:"localValueOther"}}):_vm._e()],1):_vm._e(),(
      _vm.showType == 'form-viewer' ||
        (_vm.showType == 'e-form' && !_vm.properties.eFormEditable)
    )?_c('b-form-group',{attrs:{"label":_vm.computedConditions.label
        ? _vm.superComputeFormSubmitterValue({
            elementId: this.id,
            property: 'label',
            value: _vm.properties.label,
            defaultValue: '',
            form: this.form
          })
        : _vm.properties.label}},[_vm._v(" "+_vm._s(_vm.controlValueText)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }